import React, { useState } from "react";
import { toast } from "./ui/sonner";
import { Loader2, Send, X, Copy } from "lucide-react";

// 一键生成业主只读方案预览链接 + 二维码（展示已保存的 ADU 布局方案/效果图），供设计师秒发客户确认。
export default function ProposalShareButton({ api, leadId, zh, className = "", label }) {
  const [busy, setBusy] = useState(false);
  const [modal, setModal] = useState(null); // {url, qr}
  const share = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/crm/leads/${leadId}/proposal-share`);
      const url = `${window.location.origin}/proposal/${data.token}`;
      let qr = null;
      try { const res = await api.get(`/crm/proposal-qr?data=${encodeURIComponent(url)}`, { responseType: "blob" }); qr = URL.createObjectURL(res.data); } catch { /* */ }
      setModal({ url, qr });
    } catch (e) { toast.error(e?.response?.data?.detail || (zh ? "生成失败" : "Failed")); }
    setBusy(false);
  };
  const copy = () => { try { navigator.clipboard.writeText(modal.url).catch(() => {}); } catch { /* */ } toast.success(zh ? "链接已复制" : "Copied"); };
  const [smsBusy, setSmsBusy] = useState(false);
  const sendSms = async () => {
    setSmsBusy(true);
    try {
      const { data } = await api.post(`/crm/leads/${leadId}/proposal-share/sms`);
      toast.success(zh ? `已短信发送给业主 ${data.to}` : `Texted to ${data.to}`);
    } catch (e) { toast.error(e?.response?.data?.detail || (zh ? "发送失败" : "Failed")); }
    setSmsBusy(false);
  };
  return (
    <>
      <button onClick={share} disabled={busy} data-testid={`proposal-share-btn-${leadId}`}
        className={className || "inline-flex items-center gap-1 text-[12px] text-white bg-violet-600 hover:bg-violet-700 rounded-lg px-2.5 py-1.5 disabled:opacity-50"}>
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />}{label || (zh ? "业主预览链接" : "Owner link")}
      </button>
      {modal && (
        <div className="fixed inset-0 z-[95] bg-black/60 flex items-center justify-center p-4" data-testid={`proposal-share-modal-${leadId}`} onClick={() => setModal(null)}>
          <div className="bg-white rounded-2xl w-full max-w-sm p-5 text-center" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-3"><h3 className="font-bold text-slate-800 text-sm">{zh ? "业主方案预览（含二维码）" : "Owner preview"}</h3><button data-testid={`proposal-share-close-${leadId}`} onClick={() => setModal(null)}><X className="h-5 w-5 text-slate-400" /></button></div>
            {modal.qr && <img src={modal.qr} alt="QR" data-testid={`proposal-share-qr-${leadId}`} className="w-48 h-48 mx-auto rounded-lg border border-slate-100" />}
            <p className="text-[11px] text-slate-400 mt-2">{zh ? "业主扫码即可查看 ADU 方案并在线确认" : "Scan to view & accept"}</p>
            <div className="mt-3 flex items-center gap-1">
              <input readOnly value={modal.url} data-testid={`proposal-share-url-${leadId}`} className="flex-1 text-[11px] border border-slate-200 rounded-md px-2 py-1.5 truncate" />
              <button data-testid={`proposal-share-copy-${leadId}`} onClick={copy} className="inline-flex items-center gap-1 text-[11px] text-white bg-violet-600 hover:bg-violet-700 rounded-md px-2 py-1.5"><Copy className="h-3 w-3" />{zh ? "复制" : "Copy"}</button>
            </div>
            <button data-testid={`proposal-share-sms-${leadId}`} onClick={sendSms} disabled={smsBusy}
              className="mt-2 w-full inline-flex items-center justify-center gap-1 text-[12px] text-white bg-emerald-600 hover:bg-emerald-700 rounded-md px-2 py-1.5 disabled:opacity-50">
              {smsBusy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />}{zh ? "短信直发业主" : "Text link to owner"}
            </button>
            <p className="text-[10px] text-slate-400 mt-1">{zh ? "微信发送：点「复制」后粘贴到微信即可" : "For WeChat: copy the link and paste it"}</p>
            <a href={modal.url} target="_blank" rel="noreferrer" className="inline-block mt-2 text-[11px] text-indigo-600 underline">{zh ? "预览方案页" : "Preview"}</a>
          </div>
        </div>
      )}
    </>
  );
}
